<template>
  <!-- Button trigger modal -->
  <!--<button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#modalBanner">
      Launch demo modal
  </button>-->

  <!-- Modal -->

  <!-- GAME INTERFACE-->
  <div class="modal overflow-hidden" id="modalBannerLottery" tabindex="-1" aria-labelledby="modalBannerLabel"
    aria-hidden="true">
    <transition name="fadeOut">
      <div class="modal-dialog modal-dialog-centered" v-show="isSelected == 1">
        <!-- INITIAL GAME INTERFACE-->
        <div class="modal-content modal-lottery--background__color lottery-modal col-12  rounded-0 "
          :class="{ 'lottery-modal--hide': isSelected }">
          <div class="text-end">
            <button type="button" class="btn-close p-2 position-absolute end-0 pe-3" data-bs-dismiss="modal"
              aria-label="Close" id="closeBtn"><img src="../assets/icons/close-white.svg" alt=""></button>
          </div>
          <div class="modal-body p-0 text-center text-white">
            <div class="container-fluid">
              <div class="row">
                <div class="col-12 px-0">
                  <img src="../assets/images/campaigns/2026/4th-july/deco-01.png" alt=""
                    class="img-fluid position-absolute top-0 start-0 z-0">
                </div>
                <div class="col-12 d-grid lh-1 my-4">
                  <div class="d-flex justify-content-center text-center"><img
                      src="../assets/images/campaigns/2026/4th-july/lbl-01.png" alt="" class="w-75 z-3"></div>
                  <div class="d-grid lh-base ">
                    <span class="fs-4 fw-semibold"> Try your luck and reveal</span>
                    <span>your escape bonus</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="container px-4">
              <div class="row gx-3 bg-gold p-2 p-lg-3 border-0 rounded">
                <div class="bg-red--dark py-2">
                  <div class="bg-red--light d-flex py-1 border-0 rounded">
                    <div class="col p-1" v-for="(seg, i) in 5" :key="i">
                      <div class="lottery-segment px-2 py-4 border rounded" :class="{ shuffling: isSpinning }">
                        <img :src="getSegmentImage(i)" alt="" class="img-fluid">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row my-4 my-lg-4 mb-lg-4">
                <div class="col d-flex justify-content-center">
                  <button class="btn btn-light btn-play px-4 py-0 border-0 rounded-5" @click="spinAndStop"
                    :disabled="isSpinning">SPIN & WIN</button>
                </div>
              </div>
              <div class="row justify-content-center">
                <div class="col-12 col-lg-10">
                  <p class="lh-sm  lbl-terms">
                    Does not apply with other promotions <br>
                    Valid with the purchase of a Vacation Package to Mexico. <br>
                    *only with the purchase of a $599 package. <br>
                  </p>
                </div>
                <div class="col-12 py-3">
                  <img src="../assets/images/campaigns/2026/4th-july/logo.png" alt="" class="logo--w">
                </div>
              </div>
            </div>
            <div class="container-fluid">
              <div class="row p-0">
                <div class="col p-0">
                  <!-- <img src="../assets/campaigns/2025/holidays/decoration-bottom.png" alt="" class="img-fluid"> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- PRIZE INTERFACE-->
    <transition name="fadeIn">
      <div class="modal-dialog modal-dialog-centered" v-if="isSelected == 2">
        <div class="modal-content modal-prize--background__color prize-modal col-12 rounded-0">
          <div class="col-12">
             <img src="../assets/images/campaigns/2026/4th-july/deco-01.png" alt=""
                    class="img-fluid position-absolute top-0 start-0 z-0">
          </div>
          <div class="text-end position-absolute end-0">
            <button type="button" class="btn-close p-2 position-absolute end-0 pe-3" data-bs-dismiss="modal"
              aria-label="Close" id="closeBtn"><img src="../assets/icons/close-white.svg" alt=""></button>
          </div>
          <div class="modal-body p-0 text-center text-white">
            <!-- <img src="../assets/campaigns/2025/holidays/decoration-top.png" alt="" class="img-fluid"> -->
            <div class="d-grid lh-sm justify-content-center pt-3">
              <span class="fs-1-lbl oleo-script-bold">Congrats</span>
              <span class="fs-6 fw-semibold">YOU UNLOCKED:</span>
              <div class="col mb-3"><img :src="prize.imgUrl" alt="" class="prize-item prize-up"></div>
              <div class="col-8 text-center mx-auto my-3 mb-4">
                Your bonus is ready for your
                next vacation! <br>
                Register to claim it!
              </div>
            </div>
            <the-lottery-form :prizeCode="prize.code" :prizeName="prize.name" />

            <!-- <img src="../assets/campaigns/2025/holidays/decoration-bottom.png" alt="" class="img-fluid"> -->

          </div>
        </div>
      </div>
    </Transition>

    <!-- FINAL INTERFACE-->
    <transition name="fadeIn">
      <div class="modal-dialog modal-dialog-centered" v-if="isSelected == 3">
        <div class="modal-content modal-lottery--background__color prize-modal col-12">
          <div class="modal-header modal-header--prize text-center">
            <div class="col">
              <h4 class="modal-title modal-title--prize">THANK YOU!</h4>
            </div>
            <button type="button" class="btn-close p-2" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body p-0 text-center text-white">
            <h4 class="lbl-redem p-5 pb-2">FOR PLAYING AND <br> REGISTERING<br> YOUR INFORMATION </h4>
            <h4 class="montserrat-lbl-01 pb-5 lbl-05">A VACATION EXPERT WILL <br> CONTACT YOU SHORTLY</h4>
          </div>
        </div>
      </div>
    </Transition>
    <div class="position-fixed bottom-0 end-0 w-100 validation-toast">
      <div class="d-lg-flex justify-content-end">
        <div id="liveToast" class="toast text-bg-danger w-100" role="alert" aria-live="assertive" aria-atomic="true"
          data-bs-delay="3000">
          <div class="toast-header">
            <strong class="me-auto pe-3">Please provide this information</strong>
            <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import TheLotteryForm from './TheLotteryForm.vue';
import Confetti from 'canvas-confetti'

export default {
  setup() {
    const getImageUrl = (name) => {
      return new URL(`../assets/${name}`, import.meta.url).href
    }
    return {
      getImageUrl
    }
  },
  data() {
    return {
      bannerUrl: "",
      now: new Date(),
      fromDate: new Date(2025, 3, 10, 0, 0, 0),
      toDate: new Date(2025, 4, 20, 23, 59, 59),
      fromSecondDate: new Date(2025, 1, 24, 0, 0, 0),
      toSecondDate: new Date(2025, 2, 1, 23, 59, 59),
      now: new Date(),
      isSelected: 1,
      isRinging: false,
      isActive: false,
      isPrizeShown: false,
      prize:
      {
        name: '',
        code: '',
        imgUrl: '',
      },
      // images:
      //   [
      //     require('@/assets/images/campaigns/independence-day-2024/pirinola/01.png'),
      indexImages: 0,
      imageStyle: {
        position: 'absolute',
        transition: 'transform 0.5s ease',
        transform: 'translate(-50%, -50%)',
      },
      // spinning state
      segments: [0, 1, 2, 3, 4],
      segmentTimers: [],
      isSpinning: false,
      hasSpunOnce: false,
    }
  },
  components: {
    TheLotteryForm
  },
  methods: {
    showModal() {
      let bannerModal = document.querySelector('#modalBannerLottery');
      //eslint-disable-next-line
      const bannerModalInstance = new bootstrap.Modal(bannerModal);
      bannerModalInstance.show();
    },
    showPrize() {
      setTimeout(() => {
        this.isPrizeShown = true
      }, 500);
    },
    setSelected(selected) {
      //  let selectedIcon = document.querySelector(`.${selected}`);
      //selectedIcon.classList.add('swing--selected-state');
      this.isActive = true
      this.getConfetti
      setTimeout(() => {
        this.isSelected = 2
      }, 1000);
    },
    setRandomNumber(max) {
      return Math.floor(Math.random() * max);
    },
    setPrize() {
      switch (this.setRandomNumber(4)) {
        case 0:
          this.prize.code = '#FREEVEGAS';
          this.prize.name = 'Free Vacation In Las Vegas';
          this.prize.imgUrl = require("@/assets/images/campaigns/2026/4th-july/prizes/05.png");
          break;
        case 1:
          this.prize.code = '#VAL1OODIS';
          this.prize.name = '$100 usd DISCOUNT';
          this.prize.imgUrl = require("@/assets/images/campaigns/2026/4th-july/prizes/01.png");
          break;
        case 2:
          this.prize.code = '#7NIGHTSFUN';
          this.prize.name = '7 Nights Of Fun';
          this.prize.imgUrl = require("@/assets/images/campaigns/2026/4th-july/prizes/02.png");
          break;
        case 3:
          this.prize.code = '#VAL50DIS';
          this.prize.name = '$50 usd DISCOUNT';
          this.prize.imgUrl = require("@/assets/images/campaigns/2026/4th-july/prizes/03.png");
          break;
        case 4:
          this.prize.code = '#VAL75DIS';
          this.prize.name = '$75 usd DISCOUNT';
          this.prize.imgUrl = require("@/assets/images/campaigns/2026/4th-july/prizes/04.png");
          break;
          break;
        default:
          break;
      }
    },
    // get current image path for a segment index
    getSegmentImage(i) {
      const idx = this.segments[i] ?? 0;
      const num = String(idx + 1).padStart(2, '0');
      return require(`@/assets/images/campaigns/2026/4th-july/elements/${num}.png`);
    },
    startSpin() {
      this.isSpinning = true;
      this.segmentTimers = [];
      for (let i = 0; i < 5; i++) {
        const interval = 70 + i * 10; // slight stagger per column
        this.segmentTimers[i] = setInterval(() => {
          this.segments[i] = (this.segments[i] + 1) % 5;
        }, interval);
      }
    },
    stopSpinColumn(i, forcedIndex = null) {
      const timer = this.segmentTimers[i];
      if (timer) {
        clearInterval(timer);
        this.segmentTimers[i] = null;
      }
      // land on a random image
      this.segments[i] = forcedIndex !== null ? forcedIndex : this.setRandomNumber(5);
    },
    finishSpinIfDone() {
      if (this.segmentTimers.every(t => t === null)) {
        this.isSpinning = false;
        if (!this.hasSpunOnce) {
          this.hasSpunOnce = true;
        }
        // Check if all columns aligned to same image index
        const first = this.segments[0];
        const allSame = this.segments.every(v => v === first);
        if (allSame) {
          // Map aligned image to prize
          switch (first) {
            case 0:
              this.prize.code = '#FREEVEGAS';
              this.prize.name = 'Free Vacation In Las Vegas';
              this.prize.imgUrl = require("@/assets/images/campaigns/2026/4th-july/prizes/05.png");
              break;
            case 1:
              this.prize.code = '#VAL1OODIS';
              this.prize.name = '$100 usd DISCOUNT';
              this.prize.imgUrl = require("@/assets/images/campaigns/2026/4th-july/prizes/01.png");
              break;
            case 2:
              this.prize.code = '#7NIGHTSFUN';
              this.prize.name = '7 Nights Of Fun';
              this.prize.imgUrl = require("@/assets/images/campaigns/2026/4th-july/prizes/02.png");
              break;
            case 3:
              this.prize.code = '#VAL50DIS';
              this.prize.name = '$50 usd DISCOUNT';
              this.prize.imgUrl = require("@/assets/images/campaigns/2026/4th-july/prizes/03.png");
              break;
            case 4:
          }
          // Show prize interface
          this.setSelected();
        }
      }
    },
    spinAndStop() {
      if (this.isSpinning) return;
      this.startSpin();
      // Stop each column with a slight delay for effect
      const base = 1500;
      const forced = !this.hasSpunOnce ? this.setRandomNumber(5) : null;
      for (let i = 0; i < 5; i++) {
        setTimeout(() => {
          this.stopSpinColumn(i, forced);
          this.finishSpinIfDone();
        }, base + i * 300);
      }
    },
    spinAnimation() {
      setInterval(() => {
        this.currentImage = this.images[this.indexImages];
        // Move to the next image
        this.indexImages = (this.indexImages + 1) % this.images.length;
      }, 100);
    },
    moveImage(targetCup) {
      const target = this.$refs[targetCup].getBoundingClientRect();
      const image = this.$refs.image.getBoundingClientRect();

      // Calculate the difference in position
      const dx = target.left - image.left - 10;
      const dy = target.top - image.top - 45;

      // Update the style to move the image
      this.imageStyle.transform = `translate(${dx}px, ${dy}px)`;
      this.setSelected()
    },
  },
  computed: {
    getBanner() {
      if (this.$i18n.locale == "eng") {
        this.bannerUrl = 'images/campaigns/banners/banner-fourthjuly.png'
      } else {
        this.bannerUrl = 'images/campaigns/banners/banner-fourthjuly.png'
      }
      return this.bannerUrl
    },
    getConfetti() {
      Confetti({
        particleCount: 100,
        spread: 70,
        origin: { y: 0.6 },
        zIndex: 2000,
        shapes: ['circle'],
        colors: ['#f4a8ae', '#fd9b42', '#fcde96']
      })
    }
  },
  mounted() {
    // if (this.fromDate < this.now && this.toDate > this.now) {
    //   this.setPrize();
    //   this.showModal();
    // }

  }
}

</script>

<style scoped>
.modal-lottery--background__color {
  background: #013F72;
  background: linear-gradient(50deg, rgba(1, 63, 114, 1) 0%, rgba(0, 89, 173, 1) 100%);
}

/* .modal-lottery--background__image {
  background-image: url('../assets/images/campaigns/halloween/bg-img.png');
  background-size: cover !important;
  background-repeat: no-repeat;

} */

.modal-prize--background__color {
  background: #013F72;
  background: linear-gradient(50deg, rgba(1, 63, 114, 1) 0%, rgba(0, 89, 173, 1) 100%);
}

.btn-close {
  opacity: 1 !important;
  z-index: 1 !important;
  background: none !important;

}

.modal-backdrop {
  z-index: -1;
}

.montserrat-lbl-01 {
  font-family: "Montserrat", sans-serif;
  font-optical-sizing: auto;
  font-weight: 600;
  font-style: normal;
}

.montserrat-lbl-02 {
  font-family: "Montserrat", sans-serif;
  font-optical-sizing: auto;
  font-weight: 800;
}


.lbl-03 {
  font-size: 10px !important;
}

.lbl-05 {
  color: #F1A619;
  ;
}

#modalBannerLottery {
  background-color: rgba(0, 0, 0, 0.5);
}

.logo--w {
  width: 5rem;
}

.validation-toast {
  z-index: 2000 !important;
}

.text-highlight {
  color: #f7bc24;
}

.btn-play {
  background-color: #e33737;
  color: #fff;
  font-family: "Concert One", sans-serif;
  font-weight: 800;
  font-size: 1.3rem;
  -webkit-box-shadow: 0px 23px 2px 9px rgba(172, 37, 41, 1);
  box-shadow: 0px 8px 1px 1px rgba(172, 37, 41, 1);
}

.prize-lbl {
  position: absolute !important;
  top: 12%;
  text-shadow: rgb(107, 5, 128) 7px 0px 0px, rgb(107, 5, 128) 6.92869px 0.996602px 0px, rgb(107, 5, 128) 6.71622px 1.9729px 0px, rgb(107, 5, 128) 6.36692px 2.909px 0px, rgb(107, 5, 128) 5.8879px 3.78584px 0px, rgb(107, 5, 128) 5.28893px 4.58555px 0px, rgb(107, 5, 128) 4.5822px 5.29183px 0px, rgb(107, 5, 128) 3.78212px 5.8903px 0px, rgb(107, 5, 128) 2.90498px 6.36876px 0px, rgb(107, 5, 128) 1.96865px 6.71747px 0px, rgb(107, 5, 128) 0.992221px 6.92932px 0px, rgb(107, 5, 128) -0.00442571px 7px 0px, rgb(107, 5, 128) -1.00098px 6.92806px 0px, rgb(107, 5, 128) -1.97715px 6.71498px 0px, rgb(107, 5, 128) -2.91303px 6.36508px 0px, rgb(107, 5, 128) -3.78956px 5.88551px 0px, rgb(107, 5, 128) -4.58889px 5.28603px 0px, rgb(107, 5, 128) -5.29472px 4.57885px 0px, rgb(107, 5, 128) -5.89269px 3.77839px 0px, rgb(107, 5, 128) -6.3706px 2.90095px 0px, rgb(107, 5, 128) -6.71871px 1.96441px 0px, rgb(107, 5, 128) -6.92995px 0.98784px 0px, rgb(107, 5, 128) -6.99999px -0.00885142px 0px, rgb(107, 5, 128) -6.92743px -1.00536px 0px, rgb(107, 5, 128) -6.71372px -1.98139px 0px, rgb(107, 5, 128) -6.36324px -2.91705px 0px, rgb(107, 5, 128) -5.88311px -3.79328px 0px, rgb(107, 5, 128) -5.28313px -4.59223px 0px, rgb(107, 5, 128) -4.57551px -5.29762px 0px, rgb(107, 5, 128) -3.77466px -5.89507px 0px, rgb(107, 5, 128) -2.89692px -6.37243px 0px, rgb(107, 5, 128) -1.96016px -6.71995px 0px, rgb(107, 5, 128) -0.983458px -6.93057px 0px, rgb(107, 5, 128) 0.0132771px -6.99999px 0px, rgb(107, 5, 128) 1.00974px -6.92679px 0px, rgb(107, 5, 128) 1.98564px -6.71247px 0px, rgb(107, 5, 128) 2.92107px -6.36139px 0px, rgb(107, 5, 128) 3.797px -5.88071px 0px, rgb(107, 5, 128) 4.59557px -5.28022px 0px, rgb(107, 5, 128) 5.30051px -4.57215px 0px, rgb(107, 5, 128) 5.89746px -3.77094px 0px, rgb(107, 5, 128) 6.37426px -2.89289px 0px, rgb(107, 5, 128) 6.72119px -1.95591px 0px, rgb(107, 5, 128) 6.93119px -0.979076px 0px;
}

.cursor-icon-img {
  width: 20% !important;
  position: absolute;
  bottom: 55px;
  left: 52px;
}

.item:hover {
  filter: drop-shadow(0 0 0.75rem #fd7c4c);
  transform: scale(1.1);
}

.item-width {
  width: 130%;
}

.prize--lbl-01 {
  color: #fff7ec;
  font-weight: 800;
}

.lbl-terms {
  font-size: 10px !important;
}

.margin-top {
  margin-top: 22%;
}


.prize-item-playground {
  transform: translate(-50%, 70%);
  width: 35%;
}

.prize-item {
  width: 55%;
}

.ball {
  width: 10%;
}


.moving-image {
  top: 0;
  left: 0;
}

.star-img {
  width: 5%;
  height: 5%;
}

.fs-1-lbl {
  font-family: "", sans-serif;
  font-weight: 800;
  font-style: normal;
  color: #fff;
  font-size: 2.5rem;
}

.oleo-script-bold {
  font-family: "Oleo Script", system-ui;
  font-weight: 700;
  font-style: normal;
}

.green-text {
  color: #018757;
}

.lottery-segment {
  background: #FDFBEF;
  background: linear-gradient(180deg, rgba(253, 251, 239, 1) 0%, rgba(179, 180, 182, 1) 99%);
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* simple shuffle animation while spinning */
.lottery-segment.shuffling img {
  animation: shuffle 0.25s linear infinite;
}

@keyframes shuffle {
  0% {
    transform: translateY(0);
    filter: brightness(1);
  }

  50% {
    transform: translateY(-2px);
    filter: brightness(1.1);
  }

  100% {
    transform: translateY(0);
    filter: brightness(1);
  }
}

.bg-red--light {
  background: #EC7D86;
  background: linear-gradient(180deg, rgba(236, 125, 134, 1) 0%, rgba(94, 0, 3, 1) 100%);
}

.bg-red--dark {
  background: #DF0019;
  background: linear-gradient(180deg, rgba(223, 0, 25, 1) 0%, rgba(94, 0, 3, 1) 100%);
}

.bg-gold {
  background: #808080;
  background: linear-gradient(180deg, rgba(128, 128, 128, 1) 0%, rgba(255, 255, 255, 1) 45%, rgba(255, 255, 255, 1) 56%, rgba(128, 128, 128, 1) 99%);
}

@media (min-width: 992px) {
  .btn-play {
    background-color: #e70216;
    color: #fff;
    font-family: "Montserrat", sans-serif;
    font-weight: 800;
    font-size: 1.5rem;
    -webkit-box-shadow: 0px 23px 2px 9px rgba(155, 1, 25, 1);
    box-shadow: 0px 8px 1px 1px rgba(155, 1, 25, 1);
  }

  .prize-lbl {
    top: 16%;
  }

  .cursor-icon-img {
    width: 20% !important;
    position: absolute;
    bottom: 55px;
    left: 65px;
  }

  .lbl-terms {
    font-size: 20px;

  }

  .lottery-segment {
    background: #FDFBEF;
    background: linear-gradient(180deg, rgba(253, 251, 239, 1) 0%, rgba(179, 180, 182, 1) 99%);
    height: 130px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

/* --------------- ANIMATION ------------*/

.swing--initial-state {
  animation: swing ease-in-out 1s infinite alternate;
  transform-origin: center -20px;
  float: center;
}

.swing--selected-state {
  animation: swing ease-in-out .1s infinite alternate;
  transform-origin: center -20px;
  float: center;

}

.w-50.position-absolute.z-2 {
  transform: translate(-50%, 0%);
}


.go-up-state {
  display: inline !important;
  animation: go-up ease-in-out 2s forwards;
}

.go-up-state-prize {
  animation: go-up-prize-item ease-in-out 2s forwards;
}

.swing img {
  border: 5px solid #f8f8f8;
  display: block;
}

.swing:after {
  content: '';
  position: absolute;
  width: 20px;
  height: 20px;
  border: 1px solid #999;
  top: -10px;
  left: 50%;
  z-index: 0;
  border-bottom: none;
  border-right: none;
  transform: rotate(45deg);
}

/* nail */
.swing:before {
  content: '';
  position: absolute;
  width: 5px;
  height: 5px;
  top: -14px;
  left: 54%;
  z-index: 5;
  border-radius: 50% 50%;
  background: #000;
}

@keyframes swing {
  0% {
    transform: rotate(3deg);
  }

  100% {
    transform: rotate(-3deg);
  }
}

@keyframes go-up {
  0% {
    transform: translate(-50%, 0%);
  }

  100% {
    transform: translate(-50%, -100%);
  }
}

@keyframes go-up-prize-item {
  0% {
    transform: translate(-50%, 70%);
  }

  100% {
    transform: translate(-50%, 0%);
  }
}


.modal-header--prize {
  background: rgb(154, 211, 22);
  background: linear-gradient(94deg, rgba(154, 211, 22, 1) 0%, rgba(77, 132, 16, 1) 100%);
}

.modal-title--prize {
  font-family: "Montserrat", sans-serif;
  font-weight: 800;
  font-size: 2.2rem;
  color: #173e5d;
}

.lbl-redem {
  font-family: "Montserrat", sans-serif;
  font-weight: 800;
  font-style: italic;
}

/*----Vue Transition----------- */
.fadeOut-enter-active,
.fadeOut-leave-active {
  transition: opacity .5s ease;
}

.fadeOut-enter-from,
.fadeOut-leave-to {
  opacity: 0;
}

.fadeIn-enter-active,
.fadeIn-leave-active {
  transition: opacity 1.5s ease-out;
}

.fadeIn-enter-from,
.fadeIn-leave-to {
  opacity: 0;
}

/*--------------- Prize Animation ------------*/
.prize-down {
  animation-duration: .8s;
  animation-name: slideindown;
}

.prize-down-out {
  animation-duration: 5s;
  animation-name: slideoutdown;
}

.prize-up {
  animation-duration: 2s;
  animation-name: slideinup;
}

.prize-resize {
  animation-duration: 1s;
  animation-name: resize;
}

.green-lbl {
  color: #9bd416;
}

.img-spider {
  width: 15%;
}

@keyframes slideindown {
  from {
    translate: 0 -150vw;
    scale: 200% 1;
  }

  to {
    translate: 0 0;
    scale: 100% 1;
  }
}

@keyframes slideoutdown {
  from {
    translate: 0 0;
    scale: 100% 1;
  }

  to {
    translate: 0 150vw;
    scale: 200% 1;
  }
}

@keyframes slideinup {
  from {
    translate: 0 150vw;
    scale: 200% 1;
  }

  to {
    translate: 0 0;
    scale: 100% 1;
  }
}

@keyframes resize {
  from {
    scale: 1000% 1000%;
    opacity: 0;
  }

  to {
    scale: 100% 100%;
    opacity: 1;
  }
}

.z-3 {
  z-index: 3 !important;
}
</style>
